/* eslint-disable react/display-name */
import React, { memo, Suspense, lazy } from 'react';
import { reduxConnect } from '../../common';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { faqTypes } from './faqHelper';
import { DataFetchSpinner } from '../common/dataFetchSpinner/dataFetchSpinner';

const FaqPageView = lazy(() => import('./faqPageView'));

const mapStoreStateToProps = (storeState: any) => {
    const appState = storeState.appState.appState || {};
    const { pageId, enableFaqAndFaqGeneralPageOnWeb2 } = appState;
    return { pageId , enableFaqAndFaqGeneralPageOnWeb2 };
};

const mapDispatchToProps = {};

interface FaqPageProps { 
    pageId: string;
    enableFaqAndFaqGeneralPageOnWeb2: boolean;
}

export const FaqPage = reduxConnect(mapStoreStateToProps, mapDispatchToProps) (memo(({ pageId , enableFaqAndFaqGeneralPageOnWeb2 }: FaqPageProps) => {
    const { t } = useTranslation(['translation']);
    
    if (!pageId) {
        return null;
    }

    const activeFaq = faqTypes[pageId];
    const type = activeFaq?.type;
    const name = t(activeFaq?.name);
    const title = `${name} ${t('questions')}`;
    const activePageSections = activeFaq?.sections;
    
    return (
        <Suspense fallback={
            <SuspenseSpinnerContainer>
                <DataFetchSpinner width={65} height={65} strokeWidth={6} />
            </SuspenseSpinnerContainer>
        } >
            <FaqPageView 
                pageId={pageId}
                type={type}
                name={name}
                title={title}
                activePageSections={activePageSections}
                enableFaqAndFaqGeneralPageOnWeb2={enableFaqAndFaqGeneralPageOnWeb2}
            />
        </Suspense>
    );
}));

const SuspenseSpinnerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    opacity: 0.3;
    width: 100%;
    height: 100vh;
`;
